<template>
  <div class="pm200">
    <img src="../assets/img/banner.jpg" class="banner w100 cz" />
    <div class="kjnjsfoer pd pt20">
      <p class="fz16 z3">参观日期</p>
      <div class="row">
        <div
          class="kjmmjknmxer cen mr15"
          v-for="(date, idx) in options.dates"
          :key="date.date"
          :class="{
            act: orderInput.travelDate === date.date,
            disabled: date.disable,
          }"
          @click="dateChanged(idx)"
        >
          <p class="fz12 z3 dfgdt">{{ date.text.substr(0, 2) }}</p>
          <div class="cen btm zts pt10" style="font-size: 14px">
            {{ date.disable ? "不可订" : date.text.substr(2) }}
          </div>
        </div>
        <div class="col">
          <div class="kjmmjknmxer cen mr15 w100" @click="selectMoreDate">
            <p class="fz12 z3 dfgdt">更多</p>
            <div class="cen btm zts fz16 pt5">
              <i class="f_i gengdder"></i>
            </div>
          </div>
        </div>
      </div>
      <p class="mt15 fz16">
        参观区域<span class="z9 fz12" v-if="!ticketTypeIds"> (选择参观区域再选择参观时段)</span>
      </p>
      <van-grid
        v-if="grounds[0]"
        :border="false"
        :column-num="2"
        style="margin-right: -10px"
      >
        <van-grid-item
          v-for="ground in grounds[0].children"
          :key="ground.value"
          :name="ground.value"
        >
          <div
            class="row fgdrtwer"
            :class="[
              ground.disabled || wxLastBookTime ? 'acb' : '',
              orderInput.groundId == ground.value ? 'act' : '',
            ]"
            @click="groundChange(ground)"
          >
            <div class="kmmxeert">
              <i class="f_i gounmxer" v-if="!ground.disabled"></i>
              <div v-else class="kjnmkxerse">闭<br />馆</div>
            </div>
            <div class="col pl5 pr5 z3 fz14 kmmxeert2">
              {{ ground.displayText }}
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <van-row>
        <div v-if="wxLastBookTime" class="panel-content">
          <div class="content-text2">
            超过今天最晚预约时间 {{ wxLastBookTime }}
          </div>
        </div>
      </van-row>
      <p class="mt15 fz16">
        参观时段<span class="z9 fz12"> (在该时段入场参观)</span>
      </p>
      <van-grid
        v-if="!wxLastBookTime && orderInput.groundId && changCis[0]"
        :border="false"
        :column-num="2"
        style="margin-right: -10px"
      >
        <van-grid-item
          v-for="changCi in changCis[0].children"
          :key="changCi.value"
          :name="changCi.value"
        >
          <div
            class="fgdrtwerab"
            :class="[orderInput.changCiId == changCi.value ? 'act' : '']"
            @click="changCiChange(changCi)"
          >
            <p class="fz17 z6">{{ changCi.text }}</p>
            <p class="zts fz12">{{ "(余票:" + changCi.surplusNum + ")" }}</p>
          </div>
        </van-grid-item>
      </van-grid>
      <div v-if="!wxLastBookTime && !orderInput.groundId" class="panel-content">
        <div class="content-text2">请先选择参观区域</div>
      </div>
      <p class="mt15 fz16">参观人信息</p>
      <div v-if="!addChildren">
        <div class="mt15 row mb10">
          <p v-if="options.individualOrderMaxPersonalQuantity > 1" class="col fz16">
            参观人数
          </p>
          <van-stepper
            v-if="options.individualOrderMaxPersonalQuantity > 1"
            async-change
            :value="adultQuantity"
            :defaultValue="1"
            :min="1"
            :max="maxAdultQuantity"
            @change="onAdultQuantity"
            integer
          />
        </div>
        <div class="sdfsdtywer">
          <div v-for="(adult, index) in orderInput.adults" :key="index">
            <van-cell-group>
              <van-field
                ref="adultName"
                class="adultName"
                label="姓名"
                :maxlength="30"
                placeholder="必填，输入证件上的姓名"
                v-model="adult.name.value"
                :error="adult.name.error"
                clearable
              />
              <van-cell
                is-link
                title="证件类型"
                :value="adult.certTypeName || '请选择'"
                @click="onShowCertType(adult)"
                :value-class="adult.certTypeId ? 'z3' : ''"
              />
              <van-field v-if="adult.certTypeId==5"
                clickable
                :label="adult.certNo.label"
                ref="certNo"
                class="certNo"                    
                maxlength="18"
                :placeholder="adult.certNo.placeholder"
                v-model="adult.certNo.value" 
                :error="adult.certNo.error"                   
                clearable
                @focus="onCertNoFocus(index)"
                @touchstart.native.stop="onShowNumberKeyboard(index)"
              />
              <van-field v-else
                ref="certNo"
                :label="adult.certNo.label"
                :error="adult.certNo.error"
                v-model="adult.certNo.value"
                :placeholder="adult.certNo.placeholder"
                clearable
              />
            </van-cell-group>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mt15 row mb10">
          <p class="col fz14">携带儿童成人
            <!-- <span style="color:red; font-weight:600;">（儿童及本人使用此身份证检票入馆）</span> -->
          </p>
        </div> 
        <div class="sdfsdtywer">
          <div>
            <van-cell-group v-if="orderInput.adults.length>0">
              <van-field
                ref="adultName"
                class="adultName"
                label="姓名"
                :maxlength="30"
                placeholder="必填，输入证件上的姓名"
                v-model="orderInput.adults[0].name.value"
                :error="orderInput.adults[0].name.error"
                clearable
              />
              <van-cell
                is-link
                title="证件类型"
                :value="orderInput.adults[0].certTypeName || '请选择'"
                @click="onShowCertType(orderInput.adults[0])"
                :value-class="orderInput.adults[0].certTypeId ? 'z3' : ''"
              />
              <van-field v-if="orderInput.adults[0].certTypeId==5"
                clickable
                :label="orderInput.adults[0].certNo.label"
                ref="certNo"
                class="certNo"                    
                maxlength="18"
                :placeholder="orderInput.adults[0].certNo.placeholder"
                v-model="orderInput.adults[0].certNo.value" 
                :error="orderInput.adults[0].certNo.error"                   
                clearable
                @focus="onCertNoFocus(0)"
                @touchstart.native.stop="onShowNumberKeyboard(0)"
              />
              <van-field v-else
                ref="certNo"
                :label="orderInput.adults[0].certNo.label"
                :error="orderInput.adults[0].certNo.error"
                v-model="orderInput.adults[0].certNo.value"
                :placeholder="orderInput.adults[0].certNo.placeholder"
                clearable
              />
            </van-cell-group>
            <div class="pr15 pl15 mb15" v-if="options.individualOrderMaxChildrenQuantity > 0">
              <div class="mt15 row mb10">
                <p class="col fz14" style="margin-top:5px;">添加儿童<span style="color:#A9716D;">（可携带{{ options.individualOrderMaxChildrenQuantity }}名儿童）</span></p>
                <van-stepper
                  async-change
                  :value="childrenQuantity"
                  :defaultValue="0"
                  :min="0"
                  :max="maxChildrenQuantity"
                  @change="onChildrenQuantity"
                  integer
                />
              </div>             
              <div v-if="childrenQuantity>0" class="sdfsdtywer2">
                <div v-for="(child, index) in orderInput.children" :key="index">
                  <van-cell-group>
                    <van-field
                      ref="childrenName"
                      label="姓名"
                      :maxlength="30"
                      placeholder="必填，输入证件上的姓名"
                      v-model="child.name.value"
                      :error="child.name.error"
                      clearable
                    ></van-field>
                    <van-field
                      ref="childrenAge"
                      label="年龄"
                      type="digit"
                      :maxlength="2"
                      placeholder="必填，输入年龄"
                      v-model="child.age.value"
                      :error="child.age.error"
                      clearable
                    ></van-field>
                  </van-cell-group>
                </div>
              </div>
            </div>          
            
          </div>
        </div>
        <div v-if="options.individualOrderMaxAdultQuantity > 1">
          <div class="mt15 pr15 row mb10">
            <p class="col fz14" style="margin-top:5px;">
              添加成人<span  style="color:#A9716D;">（可添加{{ options.individualOrderMaxAdultQuantity-1 }}名成人）</span>
            </p>
            <van-stepper
              async-change
              :value="adultQuantity"
              :defaultValue="0"
              :min="0"
              :max="maxAdultQuantity-1"
              @change="onAdultQuantity"
              integer
            />
          </div>
          <div class="sdfsdtywer">
            <div v-for="(adult, index) in orderInput.adults" :key="index">
              <van-cell-group v-if="index!=0">
                <van-field
                  ref="subAdultName"
                  class="adultName"
                  label="姓名"
                  :maxlength="30"
                  placeholder="必填，输入证件上的姓名"
                  v-model="adult.name.value"
                  :error="adult.name.error"
                  clearable
                />
                <van-cell
                  is-link
                  title="证件类型"
                  :value="adult.certTypeName || '请选择'"
                  @click="onShowCertType(adult)"
                  :value-class="adult.certTypeId ? 'z3' : ''"
                />
                <van-field v-if="adult.certTypeId==5"
                  clickable
                  :label="adult.certNo.label"
                  ref="certNo"
                  class="certNo"                    
                  maxlength="18"
                  :placeholder="adult.certNo.placeholder"
                  v-model="adult.certNo.value" 
                  :error="adult.certNo.error"                   
                  clearable
                  @focus="onCertNoFocus(index)"
                  @touchstart.native.stop="onShowNumberKeyboard(index)"
                />
                <van-field v-else
                  ref="certNo"
                  :label="adult.certNo.label"
                  :error="adult.certNo.error"
                  v-model="adult.certNo.value"
                  :placeholder="adult.certNo.placeholder"
                  clearable
                />
              </van-cell-group>
            </div>
          </div>
        </div>
      </div>
      
    
    </div>
    <!-- <div v-if="packingLotId">
      <p class="mt15 fz16 pm10 pd">
        停车位信息
      </p>
      <van-cell-group class>
        <van-cell title="需要停车位" class="field-cell left">
          <div class="explain">
            <van-switch
              v-model="needPackingLot"
              size="18px"
              class="group-order-switch"
              active-color="#845F56"
            />
          </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group v-if="needPackingLot && packingLotId">
        <van-cell
          title="车辆类型"
          :value="carTypeName || '请选择'"
          :value-class="orderInput.carTypeId ? 'z3' : ''"
        />
        <van-field
          label="车牌号码"
          placeholder="必填，请输入车牌号码"
          clearable
          maxlength="8"
          :value="orderInput.licensePlateNumber"  
          @input="onLicensePlateNumberInput"        
        />
      </van-cell-group>
    </div> -->
    <p class="mt15 fz16 pm10 pd">联系人信息</p>
    <van-cell-group>
      <van-field
        ref="mobile"
        label="手机号码"
        :maxlength="11"
        placeholder="必填，请输入联系人手机号码"
        type="tel"
        v-model="orderInput.contact.mobile"
        :error="orderInput.contact.error"
        clearable
      ></van-field>
    </van-cell-group>
    <div class="pd pt10 pm10 fz14 checkbox" >
      <van-checkbox
        shape="square"
        :value="checked"
        @click="onValidDateInput"
        icon-size="16px"
        checked-color="#845F56"
      > 请认真填写上述信息，填写内容需真实有效，如果填写信息有误，您个人需承担相应法律责任，请配合现场工作人员各项措施和要求。
      </van-checkbox>
      <bottom-button
        text="提交"
        :loading="loading"
        @click="onSubmit"
        :class="(!checked)?'sdrtter':''"
      ></bottom-button>
    </div>
    <div v-for="(adult, index) in orderInput.adults" :key="index">      
        <van-number-keyboard
          safe-area-inset-bottom
          theme="custom"
          class=""
          :title="
            adult.certNo.value
              ? '身份证：' + adult.certNo.value
              : '请输入' +
                (adult.name.value ? adult.name.value + '的' : '') +
                '身份证号码'
          "
          v-model="adult.certNo.value"
          :show="showNumberKeyboards[index].show"
          :maxlength="18"
          extra-key="X"
          close-button-text="完成"
          @blur="onBlurNumberKeyboard(index)"
        />
    </div>
    <van-action-sheet
      v-model="showCertType"
      :actions="certTypes"
      @select="onCertTypeSelect"
    />
    <van-action-sheet
      v-model="showCarType"
      :actions="carTypes"
      @select="onCarTypeSelecter"
    />
    <van-calendar
      v-model="showDateTimePicker"
      @confirm="confirmMoreDate"
      color="#A9716D"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </div>
</template>

<script>
import DateSelector from "@/components/DateSelector.vue";
import DateField from "@/components/DateField.vue";
import BottomButton from "@/components/BottomButton.vue";
import IdcardField from "@/components/IdCardField.vue";
import PickerField from "./../components/PickerField.vue";
import moment from "moment";
import validate from "@/utils/validator.js";
import dateHelper from "@/utils/dateHelper.js";
import { mapState, mapMutations, mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import orderService from "@/services/orderService";
import scenicService from "./../services/scenicService.js";
import commonService from "./../services/commonService.js";
import Vue from "vue";

function Tourist() {
  this.type = "成人";
  this.name = {
    value: "",
    error: false,
    errorMessage: "",
  };
  this.certTypeId = 5;
  this.certTypeName = "二代身份证";
  this.certNo = {
    value: "",
    error: false,
    errorMessage: "",
    placeholder: "必填，请输入证件号码",
    label: "证件号码",
  };
  this.birthday = "";
}

export default {
  name: "createorder",
  components: {
    DateSelector,
    DateField,
    BottomButton,
    IdcardField,
    PickerField,
  },
  props: {
    ticketTypeIds: {
      type: String
    },
    addChildren: {
      type: [String, Boolean]
    }
  },
  data() {
    return {
      orderInput: new orderService.CreateOrderInput(),
      loading: false,
      isKeyboardPopup: false,
      grounds: [],
      changCis: [],
      certTypes: [],
      showCertType: false,
      ticketTypes: [],
      wxLastBookTime: "",
      adultQuantity: 0,
      childrenQuantity: 0,
      changCiSurplusNum: 0,
      showDateTimePicker: false,
      currentAdult: {},
      carTypes: [],
      showCarType: false,
      carTypeName: "小型车",
      packingLotId: "",
      carSpacingNum: 0,
      busSpacingNum: 0,
      needPackingLot: false,
      showNumberKeyboards: [],
      checked: false,
    };
  },
  computed: {
    childrenMinDate() {
      return moment().add(-18, "years").toDate();
    },
    maxAdultQuantity() {
      let maxQuantity =
        this.orderInput.adultQuantity == 1 ? 2 : this.orderInput.adultQuantity;
      let errorMsg = this.validDateChangCi();
      if (!errorMsg) {
        maxQuantity = 10;
        if (this.addChildren) {
          maxQuantity = 2;
          if (this.options.individualOrderMaxAdultQuantity) {
            maxQuantity = this.options.individualOrderMaxAdultQuantity;
          }
        } else {
          maxQuantity = 1;
          if (this.options.individualOrderMaxPersonalQuantity) {
            maxQuantity = this.options.individualOrderMaxPersonalQuantity;
          }
        }
        if (
          this.changCiSurplusNum <
          this.orderInput.childrenQuantity + maxQuantity
        ) {
          maxQuantity =
            this.changCiSurplusNum - this.orderInput.childrenQuantity;
        }
      }

      return maxQuantity;
    },
    maxChildrenQuantity() {
      let maxQuantity =
        this.orderInput.childrenQuantity == 0
          ? 1
          : this.orderInput.childrenQuantity;
      let errorMsg = this.validDateChangCi();
      if (!errorMsg) {
        if (
          this.options.perAdultMaxChildrenQuantity <= 0 &&
          this.options.individualOrderMaxChildrenQuantity <= 0
        ) {
          maxQuantity = 4;
        } else {
          if (this.options.perAdultMaxChildrenQuantity > 0) {
            let adultQuantity = this.orderInput.adultQuantity;
            // if (adultQuantity <= 0) {
            //   adultQuantity = 1;
            // }
            maxQuantity =
              adultQuantity * this.options.perAdultMaxChildrenQuantity;
            if (
              this.options.individualOrderMaxChildrenQuantity > 0 &&
              maxQuantity > this.options.individualOrderMaxChildrenQuantity
            ) {
              maxQuantity = this.options.individualOrderMaxChildrenQuantity;
            }
            maxQuantity;
          } else {
            maxQuantity = this.options.individualOrderMaxChildrenQuantity;
          }
        }
        if (
          this.changCiSurplusNum <
          this.orderInput.adultQuantity + maxQuantity
        ) {
          maxQuantity = this.changCiSurplusNum - this.orderInput.adultQuantity;
        }
      }

      return maxQuantity;
    },
    minDate() {
      let date = this.options.dates.filter((d) => !d.disable)[0];
      if (date) {
        return new Date(date.date);
      }
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    maxDate() {
      const date = moment().add(this.options.maxBookDays, "days").toDate();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },    
    ...mapState([
      "GDHRSSLogin",
    ]),
    ...mapState({
      options: (state) => state.orderModule.options,
      member: (state) => state.memberModule.member,
    }),
  },
  watch: {
    needPackingLot(val) {
      try {
        this.loading = true;
        if (!val) {
          this.orderInput.licensePlateNumber = "";
          this.orderInput.carTypeId = "";
          this.carTypeName = "";
        } else {
          if (!this.orderInput.groundId) {
            this.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("请选择区域");
            return;
          }
          if (!this.packingLotId) {
            this.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("该区域没有停车场");
            return;
          }
          if(!this.packingLotId)
          {
            this.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("该区域没有停车场");
            return;          
          }          
          if(this.carTypes.length>0)
          {
            if(this.carTypes[0].num<=0)
            {
              this.needPackingLot = false;
              this.orderInput.carTypeId = "";
              this.carTypeName = "";
              this.$toast("停车位不足");
              return;          
            }
            this.orderInput.carTypeId = this.carTypes[0].value;
            this.carTypeName = this.carTypes[0].name;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.adultQuantity": function (newVal, oldVal) {
      try {
        this.loading = true;
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let adult = new Tourist();
            adult.type = "成人";
            this.orderInput.adults.push(adult);
            this.showNumberKeyboards.push({ show: false });
            if(this.GDHRSSLogin && !this.orderInput.adults[0].name.value && this.member && this.member.certTypeId){
              this.orderInput.adults[0].name.value = this.member.name;
              this.orderInput.adults[0].certTypeId = this.member.certTypeId;
              this.orderInput.adults[0].certNo.value = this.member.certNo;
              this.orderInput.contact.mobile = this.member.mobile;
            }
          }
        } else {
          if (this.orderInput.adults.length + diff > 0) {
            this.orderInput.adults.length += diff;
            this.showNumberKeyboards.length += diff;
          } else {
            this.orderInput.adults.length = 0;
            this.showNumberKeyboards.length = 0;
          }
          if (this.orderInput.childrenQuantity > this.maxChildrenQuantity) {
            this.orderInput.childrenQuantity = this.maxChildrenQuantity;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.childrenQuantity": function (newVal, oldVal) {
      try {
        this.loading = true;
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let child = new Tourist();
            child.type = "儿童";
            child.age = {
              value: "",
              error: false,
              errorMessage: "",
            };
            // child.birthday = moment().format("YYYY-MM-DD");
            this.orderInput.children.push(child);
          }
        } else {
          if (this.orderInput.children.length + diff > 0) {
            this.orderInput.children.length += diff;
          } else {
            this.orderInput.children.length = 0;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.groundId": async function (newVal) {
      try {
        this.loading = true;
        this.orderInput.changCiId = "";
        this.changCis=[];
        if (newVal) {
          await this.getChangCis();
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.travelDate": async function (newVal, oldVal) {
      try {
        this.loading = true;
        this.orderInput.groundId = "";
        this.grounds = [];
        this.changCis=[];
        this.orderInput.needPackingLot=false;
        this.orderInput.carTypeId="";
        this.orderInput.licensePlateNumber="";
        this.packingLotId="";
        this.carTypes=[];
        if (dateHelper.validEqualDateNow(this.orderInput.travelDate)) {
          scenicService.validExceedWxLastBookTime().then((wxLastBookTime) => {
            this.wxLastBookTime = wxLastBookTime;
          });
        }

        if (oldVal) {
          await this.getGrounds();
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.changCiId": function (newVal) {
      try {
        this.loading = true;
        this.needPackingLot=false;
        if (newVal) {
          let changCi = this.changCis[0].children.find(
            (a) => a.value == newVal
          );
          if (changCi) {
            this.changCiSurplusNum = changCi.surplusNum;
          }
        }
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.loadOrderOptionsAsync();
    if (!this.orderInput.travelDate) {
      this.orderInput.travelDate = this.options.dates.filter(
        (d) => !d.disable
      )[0].date;
    }
    if (dateHelper.validEqualDateNow(this.orderInput.travelDate)) {
      scenicService.validExceedWxLastBookTime().then((wxLastBookTime) => {
        this.wxLastBookTime = wxLastBookTime;
      });
    }

    await this.getGrounds();

    // await this.getChangCis();

    await this.getCertTypes();

    this.orderInput.adultQuantity = 1;
  },
  mounted() {
    let clientHeight = document.documentElement.clientHeight;
    let vm = this;
    window.onresize = function () {
      let nowClientHeight = document.documentElement.clientHeight;
      vm.isKeyboardPopup = clientHeight > nowClientHeight;
      if (vm.isKeyboardPopup) {
        let top = 0;
        let element = document.activeElement;
        while (element) {
          top += element.offsetTop;

          element = element.offsetParent;
        }
        window.scrollTo(0, top - 100);
      }
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    onLicensePlateNumberInput(val){
        this.orderInput.licensePlateNumber=val.toUpperCase().replace(/\s*/g,"");
    },
    onValidDateInput(){
      if(!this.validDateInput())
      {
        this.checked = false;
        return ;
      }
      this.checked = !this.checked;
    },
    onBlurNumberKeyboard(index) {
      try{
      let certRules = [
        {
          rule: "required",
        },
      ];
      certRules.push({
                rule: "isIdCard",
              });
      let result = validate([
        {
          value: this.orderInput.adults[index].certNo.value,
          name: this.orderInput.adults[index].name.value + "证件号码",
          rules: certRules,
        },
      ]);
      Vue.set(this.orderInput.adults[index].certNo, "error", !result.success);
      Vue.set(
        this.orderInput.adults[index].certNo,
        "errorMessage",
        result.message
      );
      if (!result.success) {
        this.$toast(result.message);
      }
      }
      finally{          
      this.showNumberKeyboards[index].show = false;
      }
    },
    onCertNoFocus(index){
      if(this.showNumberKeyboards[index].show)
      {
          document.activeElement.blur();
      }      
    },
    onShowNumberKeyboard(val) {
      for (var i = 0; i < this.showNumberKeyboards.length; i++) {
        this.showNumberKeyboards[i].show = false;
      }
      // let top = 0;
      // let element = document.querySelectorAll(".certNo")[val];
      // while (element) {
      //   top += element.offsetTop;
      //   element = element.offsetParent;
      // }
      // window.scrollTo(0, top - 100);
      this.showNumberKeyboards[val].show = true;
      document.activeElement.blur();
    },
    onShowCertType(adult) {
      this.currentAdult = adult;
      this.showCertType = true;
    },
    onCertTypeSelect(item) {
      this.currentAdult.certTypeId = item.value;
      this.currentAdult.certTypeName = item.name;
      this.showCertType = false;
    },
    onShowCarType() {
      this.showCarType = true;
    },
    onCarTypeSelecter(item) {
      this.orderInput.carTypeId = item.value;
      this.carTypeName = item.name;
      this.showCarType = false;
    },
    dateChanged(index) {
      try {
        let date = this.options.dates[index];
        if (date.disable) {
          return;
        }
        this.orderInput.travelDate = date.date;

        // this.$emit("input", this.orderInput.travelDate);

        this.loading = true;
      } finally {
        this.loading = false;
      }
    },
    selectMoreDate() {
      this.showDateTimePicker = true;
    },
    confirmMoreDate(value) {
      this.showDateTimePicker = false;

      value = moment(value);
      this.orderInput.travelDate = value.format("YYYY-MM-DD");
      // this.$emit("input", this.orderInput.travelDate);
      if (
        this.options.dates.filter((d) => d.date == this.orderInput.travelDate)
          .length <= 0
      ) {
        this.options.dates[this.options.dates.length - 1] = {
          date: this.orderInput.travelDate,
          text: value.format("ddd") + value.format("MM-DD"),
          disable: false,
        };
      }
    },
    cancelMoreDate() {
      this.showDateTimePicker = false;
    },
    setDefaultTicketTypeId(grounds,ticketTypeIds){  
      this.grounds = [];
      for(var i=0;i<ticketTypeIds.length;i++)
      {
        for(var j=0;j<grounds.length;j++)
        {
          if(grounds[j].value ==  ticketTypeIds[i] && this.grounds.length==0)
          {
            this.grounds = [
              {
                text: "区域",
                children: [grounds[j]],
              },
            ];
          }

          if(grounds[j].value ==  ticketTypeIds[i] && !grounds[j].disabled)
          {
            this.grounds = [
              {
                text: "区域",
                children: [grounds[j]],
              },
            ];
            this.orderInput.groundId = ticketTypeIds[i];             
            return;
          }

        }
      }
    },
    async getGrounds() {
      this.wxLastBookTime = "";
      const grounds = await scenicService.getGroundDtosAsync({
        travelDate: this.orderInput.travelDate,
      });

      this.orderInput.groundId = "";
      //var ticketTypeIds = this.$route.query.ticketTypeIds; 
      var ticketTypeIds = [];
      if(this.ticketTypeIds){
        ticketTypeIds = this.ticketTypeIds=="0"?[]:this.ticketTypeIds.split(','); 
      }

      if(ticketTypeIds && ticketTypeIds.length>0)
      {
        this.setDefaultTicketTypeId(grounds,ticketTypeIds);
      }
      else {
        this.grounds = [
          {
            text: "区域",
            children: grounds,
          },
        ];
      }  
    },
    async getChangCis() {
      if (!this.orderInput.groundId) {
        return;
      }

      if (dateHelper.validEqualDateNow(this.orderInput.travelDate)) {
        this.wxLastBookTime = await scenicService.validExceedWxLastBookTime();
        if (this.wxLastBookTime) {
          return;
        }
      }

      this.orderInput.changCiId = "";
      

      const changCis = await scenicService.getGroundChangCiItemsAsync({
        travelDate: this.orderInput.travelDate,
        groundId: this.orderInput.groundId,
      });

      this.changCis = [
        {
          text: "场次",
          children: changCis.map((c) => {
            return {
              value: c.changCiId,
              text: c.sTime + "-" + c.eTime,
              disabled: c.disabled,
              surplusNum: c.surplusNum <= 0 ? "0" : c.surplusNum,
              packingLotId: c.packingLotId,
              carSpacingNum: c.carSpacingNum,
              busSpacingNum: c.busSpacingNum,
            };
          }),
        },
      ];
    },
    async getCertTypes() {
      const certTypes = await commonService.getCertTypeComboboxItemsAsync();
      // this.certTypes = [
      //   {
      //     text: "证件类型",
      //     children: certTypes.map((c) => {
      //       return {
      //         value: c.value,
      //         name: c.displayText,
      //         disabled: c.disabled,
      //       };
      //     }),
      //   },
      // ];
      this.certTypes = certTypes.map((c) => {
        return {
          value: c.value,
          name: c.displayText,
          disabled: c.disabled,
        };
      });
    },
    validDateInput(){
      let errorMsg = this.validDateChangCi();
      if (!errorMsg) {
        if (
          this.orderInput.adults.length + this.orderInput.children.length <
          1
        ) {
          errorMsg += "请添加参观人信息";
        }
      }
      if (errorMsg) {
        this.$toast(errorMsg);
        return false;
      } 
      else 
      {
        if (this.orderInput.adults.length > 0) {
          for (let i = 0; i < this.orderInput.adults.length; i++) {
            let adult = this.orderInput.adults[i];
            let result = validate([
              {
                value: adult.name.value,
                name: "姓名",
                rules: [
                  {
                    rule: "required",
                  },
                ],
              },
            ]);
            Vue.set(adult.name, "error", !result.success);
            Vue.set(adult.name, "errorMessage", result.message);
            if (!result.success) {
              if(this.addChildren){
                if(i==0){
                  this.$refs.adultName.focus();
                }
                else{
                  this.$refs.subAdultName[i-1].focus();
                }
              }
              else{
                this.$refs.adultName[i].focus();
              }
              this.$toast(result.message);
              return false;
            }

            let certRules = [
              {
                rule: "required",
              },
            ];
            if (adult.certTypeId == 5) {
              certRules.push({
                rule: "isIdCard",
              });
            }
            result = validate([
              {
                value: adult.certNo.value,
                name: "证件号码",
                rules: certRules,
              },
            ]);
            Vue.set(adult.certNo, "error", !result.success);
            Vue.set(adult.certNo, "errorMessage", result.message);
            if (!result.success) {
              this.$toast(result.message);
              return false;
            }
          }
        }

        if (this.orderInput.children.length > 0) {
          for (let i = 0; i < this.orderInput.children.length; i++) {
            let children = this.orderInput.children[i];
            let result = validate([
              {
                value: children.name.value,
                name: "姓名",
                rules: [
                  {
                    rule: "required",
                  },
                ],
              },
            ]);
            Vue.set(children.name, "error", !result.success);
            Vue.set(children.name, "errorMessage", result.message);
            if (!result.success) {
              this.$refs.childrenName[i].focus();
              this.$toast(result.message);
              return false;
            }

            result = validate([
              {
                value: children.age.value,
                name: "儿童年龄",
                rules: [{ rule: "required" }, { rule: "isAge" }],
              },
            ]);

            Vue.set(children.age, "error", !result.success);
            Vue.set(children.age, "errorMessage", result.message);
            if (!result.success) {
              this.$refs.childrenAge[i].focus();
              this.$toast(result.message);
              // this.$toast("请输入儿童年龄");
              return false;
            }
            if (children.age.value > 0) {
              children.birthday = moment()
                .add(-1 * children.age.value, "years")
                .add(-1, "days")
                .format("YYYY-MM-DD");
            } else {
              children.birthday = "";
            }

            result = validate([
              {
                value: children.birthday,
                name: "儿童年龄",
                rules: [
                  {
                    rule: "required",
                  },
                ],
              },
            ]);
            if (!result.success) {
              this.$refs.childrenAge[i].focus();
              this.$toast(result.message);
              // this.$toast("请输入儿童年龄");
              return false;
            }
          }
        }

        let adultQuantity = this.orderInput.adultQuantity;
        if (this.member.hasElectronicMemberCard) {
          adultQuantity++;
        }
        if (adultQuantity === 0 && this.orderInput.childrenQuantity > 0) {
          this.$toast("儿童必须有成人陪同");
          return false;
        }
        if (
          this.options.individualOrderMaxAdultQuantity > 0 &&
          this.orderInput.adultQuantity >
            this.options.individualOrderMaxAdultQuantity &&
          this.addChildren
        ) {
          this.$toast(
            "每单最多" + this.options.individualOrderMaxAdultQuantity + "个成人"
          );
          return false;
        }
        if (
          this.options.individualOrderMaxChildrenQuantity > 0 &&
          this.orderInput.childrenQuantity >
            this.options.individualOrderMaxChildrenQuantity
        ) {
          this.$toast(
            "每单最多" +
              this.options.individualOrderMaxChildrenQuantity +
              "个儿童"
          );
          return false;
        }
        if (
          this.options.perAdultMaxChildrenQuantity > 0 &&
          adultQuantity * this.options.perAdultMaxChildrenQuantity <
            this.orderInput.childrenQuantity
        ) {
          this.$toast(
            "每个成人最多携带" +
              this.options.perAdultMaxChildrenQuantity +
              "个儿童"
          );
          return false;
        }

        if(this.needPackingLot)
        {
          let result = validate([
          {
            value: this.orderInput.carTypeId,
            name: "车辆类型",
            rules: [{ rule: "required" }],
          },
          ]);
          if (!result.success) {
            this.$toast("请选择车辆类型");
            return false;
          }

          result = validate([
          {
            value: this.orderInput.licensePlateNumber,
            name: "车牌号码",
            rules: [{ rule: "required" }, { rule: "isPlateNumber" }],
          },
          ]);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }

        }



        let result = validate([
          {
            value: this.orderInput.contact.mobile,
            name: "手机号",
            rules: [{ rule: "required" }, { rule: "isMobile" }],
          },
        ]);
        Vue.set(this.orderInput.contact, "error", !result.success);
        Vue.set(this.orderInput.contact, "errorMessage", result.message);
        if (!result.success) {
          this.$refs.mobile.focus();
          this.$toast(result.message);
          return false;
        }
      }
      return true;
    },
    async onSubmit() {
        if(!this.validDateInput())
        {
          return;
        }

        try {
          if(this.addChildren)
          {
            this.orderInput.adults[0].guardianFlag=true;
          }
          let tourists = this.orderInput.adults.concat(
            this.orderInput.children
          );
          tourists = tourists.map((t) => {
            return {
              type: t.type,
              name: t.name.value,
              certTypeId: t.certTypeId,
              certNo: t.certNo.value,
              birthday: t.birthday,
              guardianFlag: t.guardianFlag,
            };
          });
          
          this.loading = true;
          let response = await orderService.createIndividualOrderAsync({
            groundId: this.orderInput.groundId,
            changCiId: this.orderInput.changCiId,
            travelDate: this.orderInput.travelDate,
            tourists: tourists,
            contact: this.orderInput.contact,
            carTypeId: this.orderInput.carTypeId,
            licensePlateNumber: this.orderInput.licensePlateNumber,
          });
          if (response.success) {
            this.$router.replace({
              name: "orderinfo",
              params: {
                listNo: response.result,
                showNavbar: true,
              },
            });
          }
        } catch (err) {
          return;
        } finally {
          this.loading = false;
        }
    },
    validDateChangCi() {
      let errorMsg = "";
      if (!this.orderInput.groundId) {
        errorMsg += "请选择区域";
      } else if (!this.orderInput.changCiId) {
        errorMsg += "请选择参观时段";
      }
      return errorMsg;
    },
    onSubPopupChange(show, height, top) {
      if (show) {
        window.scrollTo(0, top - 100);
      }
    },
    groundChange(event) {
      if (event.disabled) {
        return;
      }
      this.orderInput.changCiId = "";
      if (this.wxLastBookTime) return;
      this.orderInput.groundId = event.value;
      this.packingLotId = event.packingLotId;
      this.carSpacingNum = event.carSpacingNum;
      this.needPackingLot = false;
      this.orderInput.licensePlateNumber = "";
      this.orderInput.carTypeId="";
      this.carTypes=[];
    },
    changCiChange(event) {
      if(event.surplusNum<=0)
      {
        this.$toast("该时段没有余票，请选择其它时段");
        return;
      }
      if(event.disabled){
        this.$toast("该时段不可预订，请选择其它时段");
        return;
      }
      this.orderInput.changCiId = event.value;
      //停车场
      this.needPackingLot=false;
      this.packingLotId = event.packingLotId;
      this.carSpacingNum = event.carSpacingNum;
      this.busSpacingNum = event.busSpacingNum;
      this.carTypeName="";
      this.orderInput.carTypeId="";
      this.orderInput.licensePlateNumber="";
      this.carTypes= [];
      if(this.packingLotId)
      {        
        this.carTypes = [
           { value: 1, name: "小型车 (剩余车位数:"+ this.carSpacingNum+")", num:this.carSpacingNum },
          //{ value: 2, name: "大客车 (剩余车位数:"+ this.busSpacingNum+")", num:this.busSpacingNum },
        ];
      }
    },
    onAdultQuantity(event) {
      let errorMsg = this.validDateChangCi();
      let minNum = 0;
      if (!errorMsg) {
        if (event > this.maxAdultQuantity) {
          minNum = this.maxAdultQuantity;
        } else {
          minNum = event;
        }
        errorMsg += this.validChangCiSurplus(minNum);
      }

      if (errorMsg) {
        this.$toast(errorMsg);
      } else {
        this.adultQuantity = minNum;
        this.orderInput.adultQuantity =  this.adultQuantity+1;
      }
    },
    onChildrenQuantity(event) {
      let errorMsg = this.validDateChangCi();
      let minNum = 0;
      if (!errorMsg) {
        if (event > this.maxChildrenQuantity) {
          minNum = this.maxChildrenQuantity;
        } else {
          minNum = event;
        }
        errorMsg += this.validChangCiSurplus(minNum);
      }

      if (errorMsg) {
        this.$toast(errorMsg);
      } else {
        this.childrenQuantity = minNum;
        this.orderInput.childrenQuantity = minNum;
      }
    },
    validChangCiSurplus(quantity) {
      let errorMsg = "";
      let changCi = this.changCis[0].children.find(
        (a) => a.value == this.orderInput.changCiId
      );
      if (changCi) {
        if (changCi.surplusNum < quantity) {
          errorMsg += "剩余数量不足。";
        }
      }
      return errorMsg;
    },
    ...mapMutations([appConsts.setShowNavbar]),
    ...mapActions("orderModule", [appConsts.loadOrderOptionsAsync]),
  },
};
</script>

<style lang="scss">
.van-grid-item__content {
  padding: 0px 10px 0px 0px;
}
.van-grid-item__content--center {
  align-items: unset;
}
.tourist {
  &-tips {
    font-size: 12px;
    margin: 0 15px;
    margin-bottom: 10px;
    padding: 5px 5px;
    background-color: #f5f9f8;
    border-radius: 3px;

    span {
      padding-left: 5px;
    }
  }
}
.van-key--blue {
  background-color: #845f56;
  color: #fff;
}
.van-number-keyboard__title {
  font-size: 18px;
}
.panel-content {
  // padding: 5px 14px 10px 14px;
  .content-text {
    padding: 5px 0px 5px 0px;
    color: #c8c9cc;
    font-size: 12px;
  }
  .content-text2 {
    padding: 5px 0px 5px 0px;
    color: #c8c9cc;
    font-size: 14px;
  }
}
.checkbox{
      left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    position: fixed;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #fff;
    border-top: 1px solid #EBEAE8;
}
.van-cell__value {
   color: #969799;
}
.sdrtter {
  pointer-events: none;
  opacity: 0.4;
}
</style>
